(() => {
  if (window.projectOptimalShoppingToolsReady) return;
  window.projectOptimalShoppingToolsReady = true;
  const preferenceKey = 'project-optimal-grid-view';
  let gridView = 'compact';
  try { if (sessionStorage.getItem(preferenceKey) === 'detail') gridView = 'detail'; } catch (_) { /* Storage is optional. */ }
  const originalSizes = new WeakMap();
  const synchronizeGrid = () => {
    document.querySelectorAll('[data-collection-grid]').forEach(grid => {
      grid.dataset.gridView = gridView;
      grid.querySelectorAll('img[sizes]').forEach(img => {
        if (!originalSizes.has(img)) originalSizes.set(img, img.getAttribute('sizes'));
        img.setAttribute('sizes', gridView === 'detail' ? '(min-width: 1448px) 684px, (min-width: 750px) 48vw, 92vw' : originalSizes.get(img));
      });
    });
    document.querySelectorAll('[data-grid-controls]').forEach(controls => {
      controls.hidden = false;
      controls.querySelectorAll('[data-grid-view-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gridViewChoice === gridView)));
    });
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-card-photo-toggle]').forEach(button => {
      const card = button.closest('.product-card');
      if (!card?.querySelector('.product-card__img--secondary')) return;
      card.dataset.cardGallery = 'true';
      card.dataset.cardPhoto ||= 'first';
      button.hidden = false;
    });
    synchronizeGrid();
  };
  document.addEventListener('click', async event => {
    const layoutButton = event.target.closest('[data-grid-view-choice]');
    if (layoutButton) {
      gridView = layoutButton.dataset.gridViewChoice === 'detail' ? 'detail' : 'compact';
      try { sessionStorage.setItem(preferenceKey, gridView); } catch (_) { /* Optional per-tab preference. */ }
      synchronizeGrid();
    }
    const button = event.target.closest('[data-card-photo-toggle]');
    if (!button || button.disabled) return;
    const card = button.closest('.product-card');
    const alternate = card.dataset.cardPhoto !== 'alternate';
    const image = card.querySelector(alternate ? '.product-card__img--secondary' : '.product-card__img--primary');
    const status = card.querySelector('[data-card-photo-status]');
    if (!image) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    let loadTimeout;
    const loadController = new AbortController();
    try {
      image.loading = 'eager';
      const ready = image.decode ? image.decode() : image.complete ? Promise.resolve() : new Promise((resolve, reject) => {
        image.addEventListener('load', resolve, { once: true, signal: loadController.signal });
        image.addEventListener('error', reject, { once: true, signal: loadController.signal });
      });
      await Promise.race([ready, new Promise((_, reject) => {
        loadTimeout = setTimeout(() => reject(new Error('Image timed out')), 8000);
      })]);
      if (!image.naturalWidth) throw new Error('Image unavailable');
      if (!card.isConnected) return;
      card.dataset.cardPhoto = alternate ? 'alternate' : 'first';
      button.setAttribute('aria-pressed', String(alternate));
      button.setAttribute('aria-label', alternate ? button.dataset.labelFirst : button.dataset.labelAlternate);
      button.querySelector('[data-card-photo-count]').textContent = alternate ? '2 / 2' : '1 / 2';
    } catch (_) {
      status.textContent = 'This photo could not load. Try again or open the product.';
    } finally {
      clearTimeout(loadTimeout);
      loadController.abort();
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  initialize();
})();
